import { Component } from '@angular/core';
import { DesignSystemModule } from '../../../shared/design-system/design-system.module';
import { MonEntrepriseComponent } from './mon-entreprise/mon-entreprise.component';
import { MesInformationsComponent } from './mes-informations/mes-informations.component';
import { RecapitulatifComponent } from './recapitulatif/recapitulatif.component';
import { StepperStep } from './interfaces/stepper-step.interface';

@Component({
  selector: 'app-sign-up',
  standalone: true,
  imports: [
    DesignSystemModule,
    MonEntrepriseComponent,
    MesInformationsComponent,
    RecapitulatifComponent,
  ],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss',
})
export class SignUpComponent {
  steps: StepperStep[] = [
    {
      label: 'Mon Entreprise',
      component: MonEntrepriseComponent,
      previousButton: 'Précédent',
      nextButton: 'Suivant',
      isFinalStep: false,
      isFirstStep: true,
    },
    {
      label: 'Mes Informations',
      component: MesInformationsComponent,
      previousButton: 'Précédent',
      nextButton: 'Suivant',
      isFinalStep: false,
      isFirstStep: false,
    },
    {
      label: 'Récapitulatif',
      component: RecapitulatifComponent,
      previousButton: 'Précédent',
      nextButton: 'Confirmer',
      isFinalStep: true,
      isFirstStep: false,
    },
  ];
}
